import { z } from "zod";
import { idSchema, instantSchema, reasonSchema } from "@amber/contracts";
import { routeRefSchema } from "./records.js";

export const ROUTE_ACTIONS = {
  edit: "transcription.route_settings_changed",
  rollback: "transcription.route_rollback",
} as const;
export const ADMIN_ROUTES_REASON = "Only Admins can change processing routes";

export const PROCESSING_ROUTE_ACTIONS = {
  quarantine: "transcription.quarantine_route",
  release: "transcription.release_route",
} as const;

export const canarySchema = z.strictObject({
  route: routeRefSchema,
  percent: z.number().int().min(1).max(100),
  max_items: z.number().int().positive().nullable(),
});
export type Canary = z.infer<typeof canarySchema>;

export const routeSettingsSchema = z.strictObject({
  revision: z.number().int().nonnegative(),
  default_route: routeRefSchema,
  canary: canarySchema.nullable(),
  changed_at: instantSchema.nullable(),
  reason: z.string().nullable(),
});
export type RouteSettings = z.infer<typeof routeSettingsSchema>;

export const routeSettingsResponseSchema = z.strictObject({
  settings: routeSettingsSchema,
  routes: z.array(z.strictObject({ ref: routeRefSchema, label: z.string() })),
  canary_cohort: z.strictObject({ items: z.number().int().nonnegative(), item_ids: z.array(idSchema("itm")) }),
  can_edit: z.boolean(),
  disabled_reason: z.string().nullable(),
});
export type RouteSettingsResponse = z.infer<typeof routeSettingsResponseSchema>;

export const routeSettingsEditSchema = z
  .strictObject({
    base_revision: z.number().int().nonnegative(),
    default_route: routeRefSchema,
    canary: canarySchema.nullable(),
    reason: reasonSchema,
  })
  .refine((r) => r.canary === null || r.canary.route !== r.default_route, {
    message: "The canary route must differ from the default route",
    path: ["canary", "route"],
  });

export const routeRollbackRequestSchema = z.strictObject({
  base_revision: z.number().int().nonnegative(),
  reason: reasonSchema,
});

export const routeRollbackResultSchema = z.strictObject({
  revision: z.number().int().positive(),
  rollback_route: routeRefSchema,
  canary_cohort: z.array(idSchema("itm")),
});
